export const GA_TRACKING_ID = 'G-JJCSJTPZ4V';

// Initialize Google Analytics
export const initGA = () => {
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag('js', new Date());
  gtag('config', GA_TRACKING_ID);
};
